import { render, staticRenderFns } from "./addOwnerVotingList.vue?vue&type=template&id=4826cb0b&scoped=true"
import script from "./addOwnerVotingList.vue?vue&type=script&lang=js"
export * from "./addOwnerVotingList.vue?vue&type=script&lang=js"
import style0 from "./addOwnerVotingList.vue?vue&type=style&index=0&id=4826cb0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826cb0b",
  null
  
)

export default component.exports